import React from 'react';

const SortIndicator = ({ sortConfig, columnKey }) => {
  const isSorted = sortConfig.key === columnKey;
  const direction = isSorted ? sortConfig.direction : null;

  return (
    <span style={{ marginLeft: '8px', display: 'inline-flex', verticalAlign: 'middle' }}>
      {!isSorted && (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 15L12 20L17 15" stroke="#40189D" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M7 9L12 4L17 9" stroke="#40189D" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
      {isSorted && direction === 'asc' && (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 20V4M12 4L6 10M12 4L18 10" stroke="#40189D" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
      {isSorted && direction === 'desc' && (
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 4V20M12 20L6 14M12 20L18 14" stroke="#40189D" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </span>
  );
};

export default SortIndicator;
